import iconMoneyBack from '../../assets/images/icon-moneyback-guarantee-check.png';
import checkIcon from '../../assets/images/check-bold.svg';
import closeIcon from '../../assets/images/close-bold.svg';
import exclamationIcon from '../../assets/images/exclamation-triangle-fill.svg';
import { checkboxIconStyle } from '../UI/checkboxIconStyle';

export const useStyles = (theme) => ({
	hide: {
		display: 'none !important',
	},
	textBold: {
		fontWeight: '700 !important',
	},
	textBig: {
		fontSize: '20px !important',
	},
	textRed: {
		color: '#E52866',
	},
	pt10: {
		paddingTop: 10,
	},
	lineThrough: {
		textDecoration: 'line-through',
	},
	plansWrapper: {

	},
	pageHeader: {
		padding: theme.spacing(7, 0, 4),
		color: '#283339',
		fontFamily: 'Spartan, sans-serif',
		'& h1': {
			fontSize: 44,
			fontWeight: 700,
			lineHeight: '58px',
			letterSpacing: '-1px',
			margin: '0 0 10px 0',
		},
		'& h2': {
			fontSize: 18,
			fontWeight: 600,
			lineHeight: '30px',
			letterSpacing: '-1px',
			margin: '0 auto',
		},
		'& p': {
			fontSize: 18,
			fontWeight: 700,
			color: '#6d7173',
			fontFamily: 'Spartan, sans-serif',
			marginBottom: 30,
		}
	},
	sectionHeader: {
		color: '#6d7173',
		fontSize: 20,
		fontWeight: 700,
		lineHeight: '28px',
		padding: '10px 15px 20px',
		margin: 0,
	},
	packagesWrapper: {
		paddingBottom: 60,
		marginBottom: 0,
	},
	packageContainer: {
		//maxWidth: '390px !important',
	},
	card: {
		position: 'relative',
		zIndex: 100,
		overflow: 'visible !important',
		borderRadius: 16,
		cursor: 'pointer',
		boxShadow: 'none',
		backgroundColor: '#ffffff',
		border: '4px solid transparent',
		minHeight: 330,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		padding: '30px 15px 30px',
		//minWidth: 'calc(100% - 8px)',
		maxWidth: '480px',
		margin: '0 auto',
		color: '#525B60',
		'&:hover': {
			backgroundColor: '#ffffff',
			border: '4px solid #28D799',
			boxShadow: '0px 10px 22px rgba(109, 113, 115, 0.35)',
			transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0ms',

			'& $cardHeader': {
				'& span': {
					color: '#1C1E22',
				}
			},
			'& $planPrice': {
				color: '#283339',
			},
			'& $planFeature': {
				color: '#283339',
			},
			'& $planFooterFlag': {
				color: '#283339',
			},
			'& $sentryCheckboxLabel': {
				opacity: '1',
			}
		}
	},
	cardHeaderBadge: {
		textAlign: 'center',
		fontSize: 14,
		lineHeight: '24px',
		fontWeight: 700,
		fontFamily: 'Spartan, sans-serif',
		padding: '8px 24px 6px',
		margin: '8px 0 14px',
		background: '#84E8C5',
		zIndex: 2,
		color: '#1C1E22',
		letterSpacing: '0px',
		borderRadius: 30,
		opacity: '0.5',
	},
	cardHeaderBadgeMonth: {
		background: '#E9EAEB',
		color: '#5E6573',
		opacity: '1',
	},
	cardHeader: {
		padding: 0,
		marginBottom: 6,
		'& span': {
			color: '#525B60',
			fontSize: 18,
			fontWeight: 700,
			fontFamily: 'Spartan, sans-serif',
			letterSpacing: '-0.5px',
		}
	},
	cardContent: {
		width: '100%',
		padding: '0px !important',
	},
	cardUserPercentage: {
		left: 0,
		right: 0,
		bottom: '-44px',
		position: 'absolute',
		fontSize: '13px',
		fontWeight: 700,
		textAlign: 'center',
		color:'#1a235b',
		padding: 9,
		background: '#e1f8f1',
		borderRadius: '6px',
	},
	cardUserPercentageIcon: {
		transform: 'rotate(-81deg)',
		display: 'inline-block',
		fontSize: '12px !important',
	},
	planPriceWrapper: {
		marginLeft: '-16px',
		marginRight: '-16px',
		paddingLeft: 16,
		paddingRight: 16,
		textAlign: 'center',
	},
	planPrice: {
		fontSize: 56,
		color: '#525B60',
		fontWeight: 700,
		fontFamily: 'Spartan, sans-serif',
		textAlign: 'center',
		'& $currency': {
			fontSize: 18,
			position: 'relative',
			top: '-7px',
			left: '-5px',
		},
		'& $month': {
			fontSize: 14,
		},
	},
	planPriceShort: {
		fontSize: 18,
		marginTop: 5,
		marginBottom: 15,
	},
	planOldPrice: {
		fontSize: 15,
		lineHeight: '24px',
		letterSpacing: '-0.3px',
		color: '#A6A9AB',
		fontWeight: 600,
		fontFamily: 'Spartan, sans-serif',
		textAlign: 'center',
		marginBottom: 10,
		'& p': {
			margin: '3px 0 0 0',
		}
	},
	planShowBill: {
		'& $planOldPrice': {
			marginBottom: 18,
		},
		'& $cardHeader': {
			marginBottom: 25,
		}
	},
	planCustomTotalPrice: {
		fontSize: 16,
		color: '#28D799',
		fontWeight: 700,
	},
	planOldTotalPriceDeleted: {
		color: '#fc1028',
		textDecoration: 'line-through',
	},
	currency: {

	},
	month: {

	},
	planButton: {
		background: '#D4D6D7',
		borderRadius: 12,
		textAlign: 'center',
		fontSize: 18,
		fontWeight: 700,
		color: '#ffffff',
		padding: '18px 10px',
		marginTop: 20,
	},
	planButtonUpgrade: {
		background: '#5058C8',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	planFreeOpenBtnContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		'& $planButton': {
			padding: '18px 30px',
			cursor: 'pointer',
			margin: 0,
		}
	},
	planButtonLoading: {
		background: '#D4D6D7',
		cursor: 'not-allowed',
	},
	planBottomInfo: {
		left: 0,
		right: 0,
		bottom: '-87px',
		position: 'absolute',
		fontSize: 13,
		fontWeight: 600,
		color:'#000000',
		padding: '15px 30px',
		backgroundColor: '#FFEFDB',
		borderRadius: 10,
		textAlign: 'center',
		marginLeft: '-4px',
		marginRight: '-4px',
	},
	planBottomInfoDe: {
		bottom: '-100px',
	},
	planFooterFlag: {
		position: 'relative',
		fontSize: 16,
		fontWeight: 700,
		lineHeight: '18px',
		color: '#525B60',
		padding: '5px 15px 5px 30px',
		marginTop: 20,
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: '-1px',
			left: 0,
			width: 23,
			height: 22,
			backgroundSize: 'cover',
			backgroundImage: `url(${iconMoneyBack})`,
		},
	},
	planFeatureContainer: {
		margin: '0 10px',
		display: 'inline-block',
		textAlign: 'left',
	},
	planFeature: {
		position: 'relative',
		padding: '2.5px 0 2.5px 28px',
		fontSize: 16,
		lineHeight: '28px',
		color: '#677177',
		fontWeight: 600,
		fontFamily: 'Spartan, sans-serif',
		margin: 0,
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 4,
			left: 0,
			width: 20,
			height: 20,
			backgroundColor: '#1C9A6E',
			WebkitMaskImage: `url(${checkIcon})`,
			maskImage: `url(${checkIcon})`,
			WebkitMaskSize: '100% 100%',
			maskSize: '100% 100%',
		},
		'&$planFeaturesDeleteIcon': {
			'&::before': {
				content: '""',
				width: 20,
				height: 20,
				top: 5,
				backgroundColor: '#e52866',
				WebkitMaskImage: `url(${closeIcon})`,
				maskImage: `url(${closeIcon})`,
				WebkitMaskSize: '100% 100%',
				maskSize: '100% 100%',
			},
		},
		'&$planFeaturesExclamationIcon': {
			'&::before': {
				content: '""',
				width: 20,
				height: 20,
				top: 5,
				backgroundColor: '#FF8F00',
				WebkitMaskImage: `url(${exclamationIcon})`,
				maskImage: `url(${exclamationIcon})`,
				WebkitMaskSize: '100% 100%',
				maskSize: '100% 100%',
			},
		},
	},
	planFeatureIcons: {
		display: 'flex',
		flexWrap: 'nowrap',
		'& img': {
			marginLeft: 7,
		},
		'& span': {
			whiteSpace: 'nowrap',
		}

	},
	planFeaturesDeleteIcon: {},
	planFeaturesExclamationIcon: {},
	bestValuePackage: {
		'& $planOldPrice': {
			marginBottom: 10,
		}
	},
	freePackage: {
		'& $planPriceWrapper': {

		},
	},

	packageShort: {
		'&$packageContainer': {
			maxWidth: '480px !important',
		},
		'& $cardHeader': {
			'& span': {
				color: '#525B60',
				fontSize: 24,
			}
		},
		'& $card': {
			padding: '30px 20px 30px',
		},
		'& $planFeature': {
			color: '#525B60',
		},
	},
	upgradeMode: {
		'&$freePackage': {
			'& $card': {
				cursor: 'initial',
			}
		}
	},
	plansSeparator: {
		borderTop: '1px solid #E6E5E5',
		marginTop: 30,
		marginBottom: 30,
	},
	sentryContainer: {
		borderRadius: 6,
		background: '#F9F9F9',
		margin: '15px 0 0',
		padding: 12,
		color: '#1C1E22',
		'& label': {
			display: 'flex',
			alignItems: 'center',
			margin: 0,
		}
	},
	sentryCheckboxLabelBox: {
		width: '100%',
	},
	sentryCheckboxLabel: {
		position: 'relative',
		display: 'flex',
		fontSize: 16,
		lineHeight: '24px',
		fontWeight: 700,
		textAlign: 'left',
		color: '#1c1e22',
		paddingLeft: 5,
	},
	sentryCheckbox: {
		margin: '-6px 0 -6px -6px',
	},
	...checkboxIconStyle(),
	planUsersPickedPlan: {
		left: 0,
		right: 0,
		bottom: '-80px',
		position: 'absolute',
		fontSize: 16,
		fontWeight: 600,
		color:'#000000',
		padding: '15px 10px',
		marginLeft: '-4px',
		marginRight: '-4px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		'& span': {
			color: '#1C9A6E',
			marginRight: 10,
			'& svg': {
				width: 36,
				height: 36,
			},

		}
	},
	activePackage: {
		'& $card': {
			backgroundColor: '#ffffff',
			border: '4px solid #28D799',
			boxShadow: '0px 13px 32px rgba(109, 113, 115, 0.35)',
			transition: 'all 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		},
		'& $cardHeader': {
			'& span': {
				color: '#1C1E22',
			}
		},
		'& $planPrice': {
			color: '#283339',
		},
		'& $planFeature': {
			color: '#283339',
		},
		'& $planButton': {
			background: 'linear-gradient(90deg, #FF8F00 0%, #F86605 100%)',
		},
		'& $planFooterFlag': {
			color: '#283339',
		},
		'& $cardHeaderBadge': {
			opacity: '1',
		},
		'& $cardHeaderBadgeMonth': {
			color: '#1C1E22',
		},
		'& $sentryContainer': {
			backgroundColor: '#F1F2F4',
		},
		'& $sentryCheckboxLabel': {
			opacity: '1',
		}
	},
	V23: {
		'& $card': {
			backgroundColor: '#f9f9f9',
		},
		'& $activePackage': {
			'& $card': {
				backgroundColor: '#ffffff',
			}
		},
	},
	'@media (max-width: 959px)': {
		planBottomInfo: {
			position: 'static',
			margin: '10px 0 -16px',
			bottom: '-72px',
			'& br': {
				display: 'none',
			},
		},

		planBottomInfoDe: {
			bottom: '-100px',
		},
		activePackage: {
			'&$packageContainer': {
				marginBottom: 80,
			}
		},
		cardHeader: {
			display: 'block',
			'&>div': {
				display: 'block',
			}
		},
		planPrice: {
			fontSize: 48,
		},
		bestValuePackage: {
			order: '0 !important',
			'& $planFeature': {
				marginBottom: 0,
			},
		},
		freePackage : {
			order: '10 !important',
		},
	},
	'@media (max-width: 460px)': {
		packagesWrapper: {
			paddingBottom: 55,
		},
		card: {
			padding: '50px 15px 30px',
		},
		bestValuePackage: {
			marginTop: 12,
		},
	}
});